import { UmbracoRouteNameItem } from 'helpers/umbracoApi';
import React from 'react';

const UmbracoRouteNamesContext = React.createContext<UmbracoRouteNameItem[]>(
  [],
);

export function UmbracoRouteNamesProvider({
  value,
  children,
}: {
  value: UmbracoRouteNameItem[];
  children: React.ReactNode;
}): JSX.Element {
  return (
    <UmbracoRouteNamesContext.Provider value={value}>
      {children}
    </UmbracoRouteNamesContext.Provider>
  );
}

export function useUmbracoRouteNames(): UmbracoRouteNameItem[] {
  return React.useContext(UmbracoRouteNamesContext);
}
